import { useMetrics } from "~/hooks";
import { Metrics } from "~/lib/arrow";

// scopeMrn can be a space or workspace mrn
export const useSpaceOrWorkspaceRisk = (scopeMrn: string) => {
  const { spaceRisk, isLoading, refetch } = useMetrics({
    entityMrn: scopeMrn || "",
    metricMrns: [Metrics.SpaceRisk],
  });

  return {
    spaceRisk,
    isLoading,
    refetch,
  };
};
